import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import customFtech from '../../utils/axios';
import { addUserToLocalStorage, getUserFromLocalStorage, removeUserFromLocalStorage } from '../../utils/localStorage';
import { redirect } from '../../Config/App';
const notActiveToastID = 'notActiveToast';
const invalidCredentialsID = 'invalidCredentials';
const registerSuccessID = 'registerSuccess';
const customId = 'custom-id-yes';

const initialState = {
    isLoading: false,
    user: getUserFromLocalStorage(),
};

export const logOut = (text) => {
    toast.info(text, {
        toastId: customId,
    });
    removeUserFromLocalStorage();
};

const notActiveToast = (message) => {
    toast.warn(message, {
        toastId: notActiveToastID,
        autoClose: false,
        newestOnTop: true,
    });
    toast.dismiss(invalidCredentialsID);
    toast.dismiss(registerSuccessID);
};

const invalidCredentials = (message) => {
    toast.warn(message, {
        toastId: invalidCredentialsID,
        autoClose: false,
        newestOnTop: true,
    });
    toast.dismiss(notActiveToastID);
    toast.dismiss(registerSuccessID);
};

const registrationSuccess = (message) => {
    toast.warn(message, {
        toastId: registerSuccessID,
        autoClose: false,
        newestOnTop: true,
    });
    toast.dismiss(notActiveToastID);
    toast.dismiss(invalidCredentialsID);
};

export const registerUser = createAsyncThunk('user/registerUser', async (user) => {
    try {
        const resp = await customFtech.post('auth/register', user);
        return resp.data;
    } catch (error) {
        toast.error(`Unexpected error. Please contact an admin.`);
    }
});

export const loginUser = createAsyncThunk('user/loginUser', async (user) => {
    try {
        const resp = await customFtech.post('auth/login', user);
        return resp.data;
    } catch (error) {
        toast.error(`Unexpected error. Please contact an admin.`);
    }
});

const userSlice = createSlice({
    name: 'user',
    initialState,
    extraReducers: {
        [registerUser.pending]: (state) => {
            state.isLoading = true;
        },
        [registerUser.fulfilled]: (state, { payload }) => {
            const user = payload;
            state.isLoading = false;

            if (payload) {
                state.user = user;
                registrationSuccess(`Check your email for the activation code.`);
            } else {
                toast.error(`Username or Email unavailable, please try again.`);
            }
        },
        [registerUser.rejected]: (state) => {
            state.isLoading = false;
            toast.error(`Unexpected error. Please contact an admin.`);
        },
        [loginUser.pending]: (state) => {
            state.isLoading = true;
        },
        [loginUser.fulfilled]: (state, { payload }) => {
            if (payload) {
                if (payload.message_code === 'account_is_not_active') {
                    notActiveToast('Account not yet activated. Check your email for the activation code');
                } else if (payload.user_id) {
                    state.user = payload;
                    addUserToLocalStorage(payload);
                    redirect('dashboard');
                } else {
                    invalidCredentials('Invalid credentials, please try again.');
                }
            } else {
                invalidCredentials('Invalid credentials, please try again.');
            }
            state.isLoading = false;
        },
        [loginUser.rejected]: (state) => {
            state.isLoading = false;
            toast.error(`Unexpected error. Please contact an admin.`);
        },
    },
});

export default userSlice.reducer;
